import Animate, { AnimationTypes } from "../../../components/Animate/Animate"

export function Stat({ title, value, accent }: { title: string; value: number; accent: "orange" | "green" | "red" }) {
  const accentColor = accent === "green" ? "text-green-600" : accent === "red" ? "text-red-500" : "text-orange-600"

  return (
    <Animate type={AnimationTypes.fadeInTraslate} duration="1.2s">
      <div className="bg-white ring-2 ring-orange-200 rounded-lg p-4 shadow-sm">
        <div className="text-xs font-bold text-slate-800 uppercase tracking-wide">{title}</div>

        <div className={`text-3xl font-semibold mt-2 ${accentColor}`}>{value}</div>
      </div>
    </Animate>
  )
}
